<template>
    <MainContent title="Crear grupo">
        <template v-slot:header>
            <h3 class="card-title mb-3">Crear grupo</h3>
        </template>
        <template v-slot:content>
            <FormGrupo :grupo.sync="grupo" :loading="loading" @terminado="crearGrupo" />
        </template>
    </MainContent>    
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormGrupo from '@/components/backend/campana-emails/grupos/FormGrupo';

    export default {
        data() {
            return {
                grupo: {},
                loading: false
            }
        },
        methods: {
            async crearGrupo() {
                this.loading = true;

                try {
                    await apiService.createGrupo(this.grupo);
                    this.$toast.success('Grupo creado correctamente');
                    this.$router.push('/admin/emails/grupos');
                } catch (error) {
                    console.error('Error al crear boletín:', error);
                } finally {
                    this.loading = false;
                }
            }
        },
        components: {
            MainContent, FormGrupo
        }
    }
</script>